import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "col-md-6 discount-value-field" }
const _hoisted_5 = {
  key: 0,
  class: "customer-error discount-value-error"
}
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header card-p border-0 pt-0" }
const _hoisted_11 = { class: "card-title align-items-start flex-column" }
const _hoisted_12 = { class: "card-label fw-bolder fs-3" }
const _hoisted_13 = { class: "card-body p-0" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "discount-type-select" }
const _hoisted_16 = {
  key: 0,
  class: "customer-error d-block"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_18 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_19 = { class: "menu-item-wrapper" }
const _hoisted_20 = { class: "menu-item" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_22 = { class: "menu-item" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Select, {
        name: "priceGroup",
        target: "priceGroup",
        label: _ctx.$t('message.PRICE_GROUP'),
        placeholder: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.PRICE_GROUP')}`,
        priceGroup: _ctx.priceGroup,
        "onUpdate:priceGroup": _cache[1] || (_cache[1] = ($event: any) => (_ctx.priceGroup = $event)),
        selectData: _ctx.priceGroups,
        value: _ctx.priceGroup,
        callEmit: true,
        clearable: true,
        filterable: true,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePriceGroup(_ctx.priceGroup)))
      }, null, 8, ["label", "placeholder", "priceGroup", "selectData", "value"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Select, {
        name: "discountType",
        target: "discountType",
        label: _ctx.$t('message.DISCOUNT_TYPE'),
        discountType: _ctx.discountType,
        "onUpdate:discountType": _cache[3] || (_cache[3] = ($event: any) => (_ctx.discountType = $event)),
        selectData: _ctx.discountTypeOptions,
        value: _ctx.discountType,
        callEmit: true,
        clearable: true,
        filterable: true,
        onChange: _ctx.handleFormDiscountTypeChange
      }, null, 8, ["label", "discountType", "selectData", "value", "onChange"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Input, {
        type: "number",
        name: "discountValue",
        label: _ctx.$t('message.DISCOUNT_VALUE'),
        discountValue: _ctx.discountValue,
        "onUpdate:discountValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.discountValue = $event)),
        target: "discountValue",
        value: _ctx.discountValue,
        disabled: !_ctx.discountType
      }, null, 8, ["label", "discountValue", "value", "disabled"]),
      (_ctx.discountError)
        ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.discountError), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Input, {
        type: "number",
        name: "specialPrice",
        label: `${_ctx.$t('message.SPECIAL_PRICE')}`,
        specialPrice: _ctx.specialPrice,
        "onUpdate:specialPrice": _cache[5] || (_cache[5] = ($event: any) => (_ctx.specialPrice = $event)),
        target: "specialPrice",
        value: _ctx.specialPrice,
        disabled: true
      }, null, 8, ["label", "specialPrice", "value"])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        type: "primary",
        class: "mt-2 btn-custom",
        disabled: _ctx.priceGroupBtn,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addPriceGroup())),
        style: {"float":"right"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.priceGroupId == undefined ? _ctx.$t('message.SAVE') : _ctx.$t('message.UPDATE')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("h3", _hoisted_11, [
            _createVNode("span", _hoisted_12, _toDisplayString(`${_ctx.$t('message.PRICE_GROUPS')} ${_ctx.$t('message.LIST')}`), 1)
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_Table, {
              columns: _ctx.columns,
              rows: _ctx.groupsList,
              pagination: _ctx.pagination,
              padding: 5,
              onHandleCurrentChange: _ctx.handleCurrentChange,
              loading: _ctx.loader
            }, {
              "cell-name": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item?.price_group?.name), 1)
              ]),
              "cell-discount_type": _withCtx(({ row: item }) => [
                _createVNode("div", _hoisted_15, [
                  _createVNode(_component_Select, {
                    name: `discount_type_${item.id || item.price_group_id}`,
                    target: "discount_type",
                    discount_type: item.discount_type,
                    "onUpdate:discount_type": ($event: any) => (item.discount_type = $event),
                    selectData: _ctx.discountTypeOptions,
                    filterable: true,
                    clearable: true,
                    value: item.discount_type || '',
                    callEmit: true,
                    onChange: ($event: any) => (_ctx.handleRowDiscountTypeChange(item, $event))
                  }, null, 8, ["name", "discount_type", "onUpdate:discount_type", "selectData", "value", "onChange"])
                ])
              ]),
              "cell-discount_value": _withCtx(({ row: item }) => [
                _createVNode("input", {
                  type: "number",
                  step: "any",
                  min: "0",
                  class: ["form-control position custom", { 'is-invalid': item.discount_error }],
                  disabled: !item.discount_type,
                  max: item.discount_type === 'PERCENTAGE' ? 100 : _ctx.salePrice,
                  value: item?.discount_value,
                  onInput: ($event: any) => (_ctx.handleRowDiscountValueInput(item, $event)),
                  onKeyup: _withKeys(($event: any) => (_ctx.handleRowDiscountValueEnter(item, $event)), ["enter"])
                }, null, 42, ["disabled", "max", "value", "onInput", "onKeyup"]),
                (item.discount_error)
                  ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(item.discount_error), 1))
                  : _createCommentVNode("", true)
              ]),
              "cell-special_price_original": _withCtx(({ row: item }) => [
                _createVNode("input", {
                  type: "number",
                  step: "any",
                  class: "form-control position custom",
                  value: item?.special_price_original,
                  readonly: "",
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              "cell-actions": _withCtx(({ index: index }) => [
                _hoisted_17,
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleEdit(index)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                      ], 8, ["onClick"])
                    ]),
                    _createVNode("div", _hoisted_22, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleDelete(index)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_23,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
          ])
        ])
      ])
    ])
  ]))
}